import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { S10Contacts, S10CouponsToMyChargeHistoryPartial, S10CouponsToMyChargePartial, S10CouponsTypesResponse, S10CouponsVacationRangeResponse, S10UpdateCoupon, S10UsersByCodeResponse } from '../../../interfaces/s10Employees.interface';
import { ApprovalEmployees, ApprovalEmployeesPartial, ApprovalGroupsCompanies, ApprovalResponsables, ApprovalResponsablesPartial, CompanyEmployees, S10Response, UserAssignedCompanies } from '../../../interfaces/auth.interface';
import { cleanDuplicates } from '../../../utils/data';
import { COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_TWO, COUPONS_TO_MY_CHARGE_HISTORY_THREE, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO, LOANS_TO_MY_CHARGE_HISTORY_ONE, LOANS_TO_MY_CHARGE_HISTORY_TWO, LOANS_TO_MY_CHARGE_HISTORY_THREE, LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE, LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO, LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE } from "../../../constants/signalRequestConsts";
import { EmployeContracts, EmployeCoupons, EmployePaymentSlips } from '../../../interfaces/employeeDocuments.interface';


export type LoansToMyChargeRequestId = typeof LOANS_TO_MY_CHARGE_HISTORY_ONE | typeof LOANS_TO_MY_CHARGE_HISTORY_TWO | typeof LOANS_TO_MY_CHARGE_HISTORY_THREE;
export type LoansToMyChargeStatusRequestId = typeof LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE | typeof LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO | typeof LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE;

export type CouponsToMyChargeRequestId = typeof COUPONS_TO_MY_CHARGE_HISTORY_ONE | typeof COUPONS_TO_MY_CHARGE_HISTORY_TWO | typeof COUPONS_TO_MY_CHARGE_HISTORY_THREE;

export type InMyChargeEmployeeContractsRequestId = typeof IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE | typeof IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO | typeof IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE;

export type InMyChargeEmployeePaymentSlipsRequestId = typeof IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE | typeof IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO | typeof IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE;

export type InMyChargeEmployeeDocumentsRequestId = typeof IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE | typeof IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO | typeof IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE;

export type InMyChargeEmployeeContractsRequestFilter = 0 | 1 | 2 // Todos: 0, No Firmado: 1, Observados: 2

export type InMyChargeEmployeePaymentSlipsRequestFilter = 0 | 1 | 2 // Todos: 0, No Firmado: 1, Solo boletas del presente año: 2

export type InMyChargeEmployeeDocumentsRequestFilter = 0 | 1 | 2 // Todos: 0, No Firmado: 1, del presente año: 2
interface RequestCoupon {
    couponsTypesLoading: boolean;
    couponsTypesRequestLoading: boolean;
    couponsTypes: S10CouponsTypesResponse[];
    couponsTypesError: string;
    couponsTypesSuccess: string;
    rangeSelectedIsValid: boolean;
    useEmployeeCouponIdRequested: number | null
    useEmployeeCouponResponsables: string[]
    useEmployeeCouponResponsablesData: S10UsersByCodeResponse[];
    flowId: string;
}

export interface RequestContacts {
    isLoading: boolean;
    contacts: S10Contacts[];
    page: number;
    pageQuantity: number;
    partsReaded: number[];
    totalItems: number;
}

export interface RequestContracts {
    isLoading: boolean;
    contracts: EmployeContracts[];
    page: number;
    pageQuantity: number;
    partsReaded: number[];
    totalItems: number;
}

export interface RequestPaymentSlips {
    isLoading: boolean;
    payments: EmployePaymentSlips[];
    page: number;
    pageQuantity: number;
    partsReaded: number[];
    totalItems: number;
}


export interface RequestDocuments {
    isLoading: boolean;
    documents: any[];
    page: number;
    pageQuantity: number;
    partsReaded: number[];
    totalItems: number;
}

// export interface InMyChargeEmployeesContracts {
//     isLoading: boolean;
//     contacts: S10Contacts[];
//     page: number;
//     pageQuantity: number;
//     partsReaded: number[];
//     totalItems: number;
// }

export interface ApprovalGroups {
    companies: ApprovalGroupsCompanies[];
    companiesIsLoading: boolean;
    responsables: ApprovalResponsables[];
    responsablesPartial: ApprovalResponsablesPartial[];
    responsablesLoading: boolean;
    
    employees: ApprovalEmployees[];
    employeesPartial: ApprovalEmployeesPartial[];
    employeesLoading: boolean;
}

export interface CompanyEmployeesSlice {
    employees: CompanyEmployees[],
    loading: boolean,
    parts: number[],
    totalItems: number,
}

export interface EmployeeVacationsDetails {
    Al: string;
    Anno: string;
    CodIdentificador: string;
    Del: string;
    Descripcion: string;
    DiasAsignado: number;
    DiasAtrasados: number;
    DiasGanados: number;
    DiasPendientes: number;
    DiasProgramado: number;
    DiasTruncos: number;
    DiasUtilizado: number;
    Empresa: string;
    NroVacacionProgramada: string;
    ProgramadoSinUso: number;
    ProyectoDestino: string;
    RUC: string;
    Saldo: number;
    TotalDias: number;
}
export interface EmployeesVacationResumeSlice {
    details: EmployeeVacationsDetails[],
    loading: boolean,
    parts: number[],
    totalItems: number,
}

export interface CouponToAproveERPResponse {
    Success: 1 | 0;
    Response: string;
    Code?: string;
}

export interface PaymentSlipsSchemeTypes {
    Descripcion: string;
    NroEsquemaPlanilla: string;

}

export interface CouponsToMyCharge {
    employeesPartial: S10CouponsToMyChargePartial[];
    employeesHistoryPartial: S10CouponsToMyChargeHistoryPartial[];
    employeesHistoryTotalItems: number;
    employees: (S10CouponsToMyChargePartial & CompanyEmployees)[],
    employeesHistory: (S10CouponsToMyChargeHistoryPartial & CompanyEmployees)[],
    employeesLoading: boolean,
    parts: number[],
    totalItems: number,
    couponToApprove: (S10CouponsToMyChargePartial & CompanyEmployees) | null;
    couponToApproveLoading: boolean;
    couponToApproveERPResponse: CouponToAproveERPResponse | null;
}


export interface LoansToMyCharge {
    loans: any[],
    employeesLoading: boolean,
    parts: number[],
    totalItems: number,
    updateStatusResult: null | {success: boolean, msg: string}
}
export interface UserRequestsSlice {
    requestCoupon: RequestCoupon;
    requestContacts: RequestContacts;
    
    approvalGroups: ApprovalGroups;
    companyEmployees: CompanyEmployeesSlice;
    employeesVacationResume: EmployeesVacationResumeSlice;
    COUPONS_TO_MY_CHARGE_HISTORY_ONE: CouponsToMyCharge;
    COUPONS_TO_MY_CHARGE_HISTORY_TWO: CouponsToMyCharge;
    COUPONS_TO_MY_CHARGE_HISTORY_THREE: CouponsToMyCharge;

    
    LOANS_TO_MY_CHARGE_HISTORY_ONE: LoansToMyCharge;
    LOANS_TO_MY_CHARGE_HISTORY_TWO: LoansToMyCharge;
    LOANS_TO_MY_CHARGE_HISTORY_THREE: LoansToMyCharge;

    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE: RequestContracts;
    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO: RequestContracts;
    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE: RequestContracts;

    schemesTypes: PaymentSlipsSchemeTypes[];

    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE: RequestPaymentSlips;
    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO: RequestPaymentSlips;
    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE: RequestPaymentSlips;

    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE: RequestDocuments;
    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO: RequestDocuments;
    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE: RequestDocuments;
    staffPositions: any[];
    assignedCompanies: UserAssignedCompanies[];

    calendarEvents: EmployeCoupons[],

}

const couponsToMyChargeInitialData = {
    employees: [],
    employeesHistory: [],
    employeesPartial: [],
    employeesHistoryPartial: [],
    employeesHistoryTotalItems: 0,
    employeesLoading: false,
    parts: [],
    totalItems: 0,
    companies: [],
    couponToApprove: null,
    couponToApproveLoading: false,
    couponToApproveERPResponse: null,
}

const loansToMyChargeInitialData = {
    loans: [],
    employeesLoading: false,
    parts: [],
    totalItems: 0,
    companies: [],
    updateStatusResult: null,
}

const contractsInitialData = {
    isLoading: false,
    contracts: [],
    page: 1,
    pageQuantity: 10,
    partsReaded: [],
    totalItems: 0,
}

const paymentSlipsInitialData = {
    isLoading: false,
    payments: [],
    page: 1,
    pageQuantity: 10,
    partsReaded: [],
    totalItems: 0,
}

const documentsInitialData = {
    isLoading: false,
    documents: [],
    page: 1,
    pageQuantity: 10,
    partsReaded: [],
    totalItems: 0,
}

const initialState: UserRequestsSlice = {
    requestCoupon: {
        couponsTypesLoading: false,
        couponsTypesRequestLoading: false,
        couponsTypes: [],
        couponsTypesError: "",
        couponsTypesSuccess: "",
        rangeSelectedIsValid: false,
        useEmployeeCouponIdRequested: null,
        useEmployeeCouponResponsables: [],
        useEmployeeCouponResponsablesData: [],
        flowId: new Date().toISOString(),
    },
    requestContacts: {
        isLoading: false,
        contacts: [],
        page: 1,
        pageQuantity: 10,
        partsReaded: [],
        totalItems: 0,
    },
    approvalGroups: {
        companies: [],
        companiesIsLoading: false,
        responsables: [],
        responsablesPartial: [],
        responsablesLoading: false,
        
        employees: [],
        employeesPartial: [],
        employeesLoading: false,
    },
    companyEmployees: {
        loading: false,
        employees: [],
        parts: [],
        totalItems: 0,
    },
    employeesVacationResume: {
        loading: false,
        details: [],
        parts: [],
        totalItems: 0,
    },
    schemesTypes: [],
    COUPONS_TO_MY_CHARGE_HISTORY_ONE: couponsToMyChargeInitialData,
    COUPONS_TO_MY_CHARGE_HISTORY_TWO: couponsToMyChargeInitialData,
    COUPONS_TO_MY_CHARGE_HISTORY_THREE: couponsToMyChargeInitialData,

    LOANS_TO_MY_CHARGE_HISTORY_ONE: loansToMyChargeInitialData,
    LOANS_TO_MY_CHARGE_HISTORY_TWO: loansToMyChargeInitialData,
    LOANS_TO_MY_CHARGE_HISTORY_THREE: loansToMyChargeInitialData,

    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE: contractsInitialData,
    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO: contractsInitialData,
    IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE: contractsInitialData,
    
    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE: paymentSlipsInitialData,
    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO: paymentSlipsInitialData,
    IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE: paymentSlipsInitialData,

    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE: documentsInitialData,
    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO: documentsInitialData,
    IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE: documentsInitialData,
    staffPositions: [],
    assignedCompanies: [],
    calendarEvents: [],
}


export const userRequestsSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setStaffPositionsData: (state, {payload}: PayloadAction<any[]>) => {
            state.staffPositions = payload;
        },
        setCouponsResponsiblesData: (state, {payload}: PayloadAction<S10UsersByCodeResponse[]>) => {
            state.requestCoupon.useEmployeeCouponResponsablesData = payload;
        },
        setFlowId: (state) => {
            state.requestCoupon.flowId = new Date().toISOString();
        },
        setCouponsTypesSuccess: (state, {payload}: PayloadAction<string>) => {
            state.requestCoupon.couponsTypesSuccess = payload;
        },
        setCouponsTypesRequestLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.requestCoupon.couponsTypesRequestLoading = payload;
        },
        setCouponsTypesRequestResult: (state, {payload}: PayloadAction<S10CouponsVacationRangeResponse>) => {
            state.requestCoupon.couponsTypesSuccess = "";
            state.requestCoupon.useEmployeeCouponIdRequested = null;
            state.requestCoupon.useEmployeeCouponResponsables = [];
            state.requestCoupon.useEmployeeCouponResponsablesData = [];
            
            if (payload.Type === 0) {
                state.requestCoupon.couponsTypesSuccess = payload.Message;
                state.requestCoupon.useEmployeeCouponIdRequested = payload.Value.UseEmployeeCouponId;
                state.requestCoupon.useEmployeeCouponResponsables = payload.Value.Responsables || [];
            } else {
                state.requestCoupon.couponsTypesError = payload.Message;
            }
        },
        setEmployeeCouponIdRequested: (state, {payload}: PayloadAction<number | null>) => {
            state.requestCoupon.useEmployeeCouponIdRequested = payload;
        },
        setCouponsTypesLoading: (state, {payload}: PayloadAction<boolean>) => {
            if (payload) state.requestCoupon.couponsTypes = [];
            state.requestCoupon.couponsTypesLoading = payload;
        },
        setCouponsTypesError: (state, {payload}: PayloadAction<string>) => {
            state.requestCoupon.couponsTypesError = payload;
        },
        setCouponsTypesRangeSelectedIsValid: (state, {payload: {success, response}}: PayloadAction<{success: 1 | 0, response: string}>) => {
            state.requestCoupon.rangeSelectedIsValid = success === 1;
            state.requestCoupon.couponsTypesError = response;
        },
        setCouponsTypes: (state, {payload}: PayloadAction<S10CouponsTypesResponse[]>) => {
            state.requestCoupon.couponsTypesLoading = false;
            state.requestCoupon.couponsTypes = payload;
        },
        setCouponUpdatedData: (state, {payload}: PayloadAction<S10UpdateCoupon>) => {
            const couponsTypes = [...state.requestCoupon.couponsTypes];
            const index = couponsTypes.findIndex(d => d.CouponId === payload.CouponId);
            if (index >= 0) {
                couponsTypes[index] = {
                    ...couponsTypes[index],
                    ...payload,
                };
                state.requestCoupon.couponsTypes = couponsTypes;

            } else {
                console.log('not found', payload)
            }

        },
        setContacts: (state, {payload}: PayloadAction<S10Response<S10Contacts[]>>) => {
            if (state.requestContacts.partsReaded.includes(payload.part)) {
                return;
            }
            state.requestContacts.partsReaded = [...state.requestContacts.partsReaded, payload.part];
            const contacts: S10Contacts[] = cleanDuplicates([
                ...state.requestContacts.contacts, 
                ...payload.data],
                ["CodIdentificador", "Cargo", "CodEsquemaPlanilla"]
            );
            state.requestContacts.contacts = contacts;
            if (payload.count === state.requestContacts.partsReaded.length) {
                state.requestContacts.isLoading = false;
            }
            if (payload.outputValue) {
                state.requestContacts.totalItems = Number(payload.outputValue.split("/")[1])
            }
        },
        setLoadingContacts: (state, {payload}: PayloadAction<boolean>) => {
            state.requestContacts.isLoading = payload;
        },
        resetContactsData: (state) => {
            state.requestContacts.contacts = [];
            state.requestContacts.partsReaded = [];
        },
        setApprovalGroupsCompaniesLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.approvalGroups.companiesIsLoading = payload
        },
        setApprovalGroupsCompanies: (state, {payload}: PayloadAction<S10Response<ApprovalGroupsCompanies[]>>) => {
            const companies: ApprovalGroupsCompanies[] = cleanDuplicates([...state.approvalGroups.companies, ...payload.data], "CodIdentificador");
            companies.sort((a, b) => a.Descripcion.localeCompare(b.Descripcion));
            state.approvalGroups.companies = companies;
            state.approvalGroups.companiesIsLoading = false;
        },
        setAssignedCompanies: (state, {payload}: PayloadAction<S10Response<UserAssignedCompanies[]>>) => {
            const companies: UserAssignedCompanies[] = cleanDuplicates([...state.approvalGroups.companies, ...payload.data], "CodIdentificador");
            companies.sort((a, b) => a.CodIdentificador.localeCompare(b.CodIdentificador));
            state.assignedCompanies = companies;
            state.approvalGroups.companiesIsLoading = false;
        },
        setApprovalResponsablesLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.approvalGroups.responsablesLoading = payload;
        },
        setApprovalResponsablesReset: (state) => {
            state.approvalGroups.responsables = [];
            state.approvalGroups.responsablesPartial = [];
        },

        setApprovalResponsablesPartial: (state, {payload}: PayloadAction<ApprovalResponsablesPartial[]>) => {
            state.approvalGroups.responsablesPartial = payload;
        },
        setApprovalResponsables: (state, {payload}: PayloadAction<S10Response<ApprovalResponsables[]>>) => {
            const responsables: ApprovalResponsables[] = cleanDuplicates([...state.approvalGroups.responsables, ...payload.data], "CodIdentificador");
            const partialData = [...state.approvalGroups.responsablesPartial];
            for (let i = 0; i < responsables.length; i++) {
                const additionalData = partialData.find((p) => p.ApprovalGroupResponsableCode === responsables[i].CodIdentificador);
                if (additionalData) {
                    responsables[i] = {
                        ...responsables[i],
                        ...additionalData,
                        RoleId: additionalData.RoleId,
                        RoleName: additionalData.RoleName,
                        responsableId: additionalData.Id,
                    }
                }
                
            }
            state.approvalGroups.responsables = responsables;
            state.approvalGroups.responsablesLoading = false;
        },


        setEmployeesVacationsResumeLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.employeesVacationResume.loading = payload;
            if (payload) {
                state.employeesVacationResume.details = [];
                state.employeesVacationResume.parts = [];
                state.employeesVacationResume.totalItems = 0;                
            }
        },
        setEmployeesVacationsResume: (state, {payload}: PayloadAction<S10Response<EmployeeVacationsDetails[]>>) => {
            if (state.employeesVacationResume.parts.includes(payload.part) ) {
                return
            }
            state.employeesVacationResume.parts = [...state.employeesVacationResume.parts, payload.part]
            // const details: any[] = cleanDuplicates([...state.employeesVacationResume.details, ...payload.data], "CodIdentificador");
            state.employeesVacationResume.details = payload.data; // details;
            if (payload.count === state.employeesVacationResume.parts.length) {
                state.employeesVacationResume.loading = false;
            }
            if (payload.outputValue) {
                state.employeesVacationResume.totalItems = Number(payload.outputValue.split("/")[1])
            }
        },
        

        setCompanyEmployeesLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.companyEmployees.loading = payload;
            if (payload) {
                state.companyEmployees.employees = [];
                state.companyEmployees.parts = [];
            }
        },
        setCompanyEmployees: (state, {payload}: PayloadAction<S10Response<CompanyEmployees[]>>) => {
            if (state.companyEmployees.parts.includes(payload.part) ) {
                return
            }
            state.companyEmployees.parts = [...state.companyEmployees.parts, payload.part]
            const employees: CompanyEmployees[] = cleanDuplicates([...state.companyEmployees.employees, ...payload.data], "CodIdentificador");
            state.companyEmployees.employees = employees;
            if (payload.count === state.companyEmployees.parts.length) {
                state.companyEmployees.loading = false;
            }
            if (payload.outputValue) {
                state.companyEmployees.totalItems = Number(payload.outputValue.split("/")[1])
            }
        },

        setApprovalEmployeesReset: (state) => {
            state.approvalGroups.employees = [];
            state.approvalGroups.employeesPartial = [];
        },  
        setApprovalEmployeesLoading: (state, {payload}: PayloadAction<boolean>) => {
            state.approvalGroups.employeesLoading = payload;
        },
        setApprovalEmployeesPartial: (state, {payload}: PayloadAction<ApprovalEmployeesPartial[]>) => {
            state.approvalGroups.employeesPartial = payload;
        },
        setApprovalEmployees: (state, {payload}: PayloadAction<S10Response<ApprovalEmployees[]>>) => {
            const employees: ApprovalEmployees[] = cleanDuplicates([...state.approvalGroups.employees, ...payload.data], "CodIdentificador");
            const partialData = [...state.approvalGroups.employeesPartial];
            for (let i = 0; i < employees.length; i++) {
                const additionalData = partialData.find((p) => p.EmployeeCode === employees[i].CodIdentificador);
                if (additionalData) {
                    employees[i] = {
                        ...employees[i],
                        Id: additionalData?.Id,
                    }
                }
            }
            state.approvalGroups.employees = employees;
            state.approvalGroups.employeesLoading = false;
        },


        setCouponsToMyChargeEmployeesHistoryPartial: (state, {payload}: PayloadAction<{totalItems: number, items: S10CouponsToMyChargeHistoryPartial[], requestId: CouponsToMyChargeRequestId}>) => {
            state[payload.requestId].employeesHistoryPartial = payload.items;
            state[payload.requestId].employeesHistoryTotalItems = payload.totalItems;
        },
        setCouponsToMyChargeEmployeesHistory: (state, {payload}: PayloadAction<{data: S10Response<CompanyEmployees[]>, requestId: CouponsToMyChargeRequestId}>) => {
            const employees: (S10CouponsToMyChargeHistoryPartial & CompanyEmployees)[] = cleanDuplicates([...state[payload.requestId].employees, ...payload.data.data], "CodIdentificador");
            const partialData = [...state[payload.requestId].employeesHistoryPartial];
            const finalData: (S10CouponsToMyChargeHistoryPartial & CompanyEmployees)[] = [];
            for (let i = 0; i < partialData.length; i++) {
                const additionalData = employees.find((p) => p.CodIdentificador === partialData[i].EmployeeCode);
                const approverData = employees.find((p) => p.CodIdentificador === partialData[i].ApproverCode)
                if (additionalData) {
                    finalData.push({
                        ...additionalData,
                        ...partialData[i],
                        approverName: approverData?.Descripcion,
                    })
                }
            }
            state[payload.requestId].employeesHistory = finalData.map(e => ({...e, RUCEmpresa: e.RUCEmpresa?.replaceAll(' ', '') || null}));
            state[payload.requestId].employeesLoading = false;
        },
        
        
        setInMyChargeEmployeePaymentSlipsReset: (state, {payload}: PayloadAction<InMyChargeEmployeePaymentSlipsRequestId>) => {
            state[payload].payments = [];
            state[payload].partsReaded = [];
        },
        setInMyChargeEmployeePaymentSlipsLoading: (state, {payload}: PayloadAction<{loading: boolean, requestId: InMyChargeEmployeePaymentSlipsRequestId}>) => {
            state[payload.requestId].isLoading = payload.loading;
        },
        setEmployeePaymentSlipsSchemeTypes: (state, {payload: {data}}: PayloadAction<{data: S10Response<PaymentSlipsSchemeTypes[]>}>) => {
            console.log('setEmployeePaymentSlipsSchemeTypes', data)
            state.schemesTypes = data.data;
        },
        setInMyChargeEmployeesPaymentSlips: (state, {payload}: PayloadAction<{data: S10Response<EmployePaymentSlips[]>, requestId: InMyChargeEmployeePaymentSlipsRequestId}>) => {
            console.log(payload)
            if (state[payload.requestId].partsReaded.includes(payload.data.part)) {
                return;
            }
            state[payload.requestId].partsReaded = [...state[payload.requestId].partsReaded, payload.data.part];
            const payments: EmployePaymentSlips[] = cleanDuplicates([
                ...state[payload.requestId].payments, 
                ...payload.data.data],
                "NumeroDocumento"
            );
            state[payload.requestId].payments = payments;
            if (payload.data.count === state[payload.requestId].partsReaded.length || payload.data.count === 1) {
                state[payload.requestId].isLoading = false;
            }
            if (payload.data.outputValue) {
                state[payload.requestId].totalItems = Number(payload.data.outputValue.split("/")[1])
            }
        },


        
        
        
        setInMyChargeEmployeeDocumentsReset: (state, {payload}: PayloadAction<InMyChargeEmployeeDocumentsRequestId>) => {
            state[payload].documents = [];
            state[payload].partsReaded = [];
        },
        setInMyChargeDocumentsLoading: (state, {payload}: PayloadAction<{loading: boolean, requestId: InMyChargeEmployeeDocumentsRequestId}>) => {
            state[payload.requestId].isLoading = payload.loading;
        },
        setInMyChargeDocuments: (state, {payload}: PayloadAction<{data: S10Response<EmployePaymentSlips[]>, requestId: InMyChargeEmployeeDocumentsRequestId}>) => {
            if (state[payload.requestId].partsReaded.includes(payload.data.part)) {
                return;
            }
            state[payload.requestId].partsReaded = [...state[payload.requestId].partsReaded, payload.data.part];
            const documents: any[] = cleanDuplicates([
                ...state[payload.requestId].documents, 
                ...payload.data.data],
                "NumeroDocumento"
            );
            state[payload.requestId].documents = documents;
            if (payload.data.count === state[payload.requestId].partsReaded.length || payload.data.count === 1) {
                state[payload.requestId].isLoading = false;
            }
            if (payload.data.outputValue) {
                state[payload.requestId].totalItems = Number(payload.data.outputValue.split("/")[1])
            }
        },


        setInMyChargeEmployeeContractsReset: (state, {payload}: PayloadAction<InMyChargeEmployeeContractsRequestId>) => {
            state[payload].contracts = [];
            state[payload].partsReaded = [];
        },
        setInMyChargeEmployeeContractsLoading: (state, {payload}: PayloadAction<{loading: boolean, requestId: InMyChargeEmployeeContractsRequestId}>) => {
            state[payload.requestId].isLoading = payload.loading;
        },
        setInMyChargeEmployeesContracts: (state, {payload}: PayloadAction<{data: S10Response<EmployeContracts[]>, requestId: InMyChargeEmployeeContractsRequestId}>) => {
            if (state[payload.requestId].partsReaded.includes(payload.data.part)) {
                return;
            }
            state[payload.requestId].partsReaded = [...state[payload.requestId].partsReaded, payload.data.part];
            const contracts: EmployeContracts[] = cleanDuplicates([
                ...state[payload.requestId].contracts, 
                ...payload.data.data],
                "NroIdentificadorContrato"
            );
            state[payload.requestId].contracts = contracts;
            if (payload.data.count === state[payload.requestId].partsReaded.length) {
                state[payload.requestId].isLoading = false;
            }
            if (payload.data.outputValue) {
                state[payload.requestId].totalItems = Number(payload.data.outputValue.split("/")[1])
            }
        },



        

        setLoanUpdateStatusResult: (state, {payload}: PayloadAction<{data: any, requestId: LoansToMyChargeStatusRequestId}>) => {
            const loanRequesId = payload.requestId === LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE
                                    ? LOANS_TO_MY_CHARGE_HISTORY_ONE
                                    : payload.requestId === LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO
                                    ? LOANS_TO_MY_CHARGE_HISTORY_TWO
                                    : LOANS_TO_MY_CHARGE_HISTORY_THREE;
            state[loanRequesId].updateStatusResult = payload.data;
        },
        setLoansToMyChargeEmployeesReset: (state, {payload}: PayloadAction<LoansToMyChargeRequestId>) => {
            // state[payload].employees = [];
            // state[payload].employeesPartial = [];
            // state[payload].employeesHistoryPartial = [];
            state[payload].loans = [];
            
        },
        setLoansToMyChargeEmployeesLoading: (state, {payload}: PayloadAction<{loading: boolean, requestId: LoansToMyChargeRequestId}>) => {
            state[payload.requestId].employeesLoading = payload.loading;
        },
        setLoansToMyChargeEmployees: (state, {payload}: PayloadAction<{data: S10Response<any[]>, requestId: LoansToMyChargeRequestId}>) => {
            const loans: (S10CouponsToMyChargePartial & CompanyEmployees)[] = 
                    cleanDuplicates([
                        ...state[payload.requestId]?.loans, 
                        ...payload.data.data
                    ], "NroPrestamoPersonal");
            state[payload.requestId].loans = loans;
            state[payload.requestId].employeesLoading = false;
            if (payload.data.outputValue) {
                state[payload.requestId].totalItems = Number(payload.data.outputValue.split("/")[1])
            }
        },



        setCouponsToMyChargeEmployeesReset: (state, {payload}: PayloadAction<CouponsToMyChargeRequestId>) => {
            state[payload].employees = [];
            state[payload].employeesPartial = [];
            state[payload].employeesHistoryPartial = [];
            state[payload].employeesHistoryTotalItems = 0;
            state[payload].employeesHistory = [];
            
        },

        setDeleteCouponRejected: (state, {payload}: PayloadAction<{requestId: CouponsToMyChargeRequestId, CouponCode: string}>) => {
            state[payload.requestId].employeesHistory = state[payload.requestId]
                                                        .employeesHistory.filter(c => c.CouponCode !== payload.CouponCode);
            
        },
        setCouponsToMyChargeEmployeesLoading: (state, {payload}: PayloadAction<{loading: boolean, requestId: CouponsToMyChargeRequestId}>) => {
            state[payload.requestId].employeesLoading = payload.loading;
        },
        setCouponsToMyChargeEmployeesPartial: (state, {payload}: PayloadAction<{data: S10CouponsToMyChargePartial[], requestId: CouponsToMyChargeRequestId}>) => {
            state[payload.requestId].employeesPartial = payload.data;
        },
        setCouponsToMyChargeEmployees: (state, {payload}: PayloadAction<{data: S10Response<CompanyEmployees[]>, requestId: CouponsToMyChargeRequestId}>) => {
            const employees: (S10CouponsToMyChargePartial & CompanyEmployees)[] = cleanDuplicates([...state[payload.requestId]?.employees, ...payload.data.data], "CodIdentificador");
            const partialData = [...state[payload.requestId].employeesPartial];
            const finalData: (S10CouponsToMyChargePartial & CompanyEmployees)[] = [];
            for (let i = 0; i < partialData.length; i++) {
                const additionalData = employees.find((p) => p.CodIdentificador === partialData[i].EmployeeCode);
                if (additionalData) {
                    finalData.push({
                        ...additionalData,
                        ...partialData[i],
                    })
                }
            }
            state[payload.requestId].employees = finalData;
            state[payload.requestId].employeesLoading = false;
        },
        setCouponsToApprove: (state, {payload}: PayloadAction<{data: (S10CouponsToMyChargePartial & CompanyEmployees), requestId: CouponsToMyChargeRequestId}>) => {
            state[payload.requestId].couponToApproveLoading = true;
            state[payload.requestId].couponToApprove = payload.data;
        },
        setCouponsToApproveERPReponse: (state, {payload}: PayloadAction<{data: (CouponToAproveERPResponse | null), requestId: CouponsToMyChargeRequestId}>) => {
            if (payload.data === null) {
                state[COUPONS_TO_MY_CHARGE_HISTORY_ONE].couponToApproveERPResponse = null;
                return;
            }
            state[COUPONS_TO_MY_CHARGE_HISTORY_ONE].couponToApproveLoading = false;
            state[COUPONS_TO_MY_CHARGE_HISTORY_ONE].couponToApproveERPResponse = {
                ...payload.data,
                Success: payload?.data?.Success || 0,
                Response: payload?.data?.Response || "Ocurrió un error.",
            };
            // Code: "30153B73-821F-46FC-B1EF-86F460AB6D50;00003723"
            // Response: "Papeleta N° 00003723 se ha creado satisfactoriamente."
            // Success: 1
            if (payload?.data?.Success === 1 && payload?.data?.Code) {
                const code = payload?.data?.Code?.split(";")[0].toUpperCase();
                const couponData = state[COUPONS_TO_MY_CHARGE_HISTORY_ONE]
                                            .employeesHistory.find(c => c.ApprovalCode?.toUpperCase() === code);
                if (!couponData) {
                    return;
                }
                const newCouponData = {
                    ...couponData,
                    State: 1,
                }
                state[COUPONS_TO_MY_CHARGE_HISTORY_ONE].employeesHistory = state[COUPONS_TO_MY_CHARGE_HISTORY_ONE].employeesHistory.filter(c => c.ApprovalCode?.toUpperCase() !== code);
                state[COUPONS_TO_MY_CHARGE_HISTORY_TWO].employeesHistory = [
                    newCouponData, 
                    ...state[COUPONS_TO_MY_CHARGE_HISTORY_TWO].employeesHistory
                ];

            }
        },
        setCalendarEvents: (state, {payload}: PayloadAction<{data: EmployeCoupons[]}>) => {
            // console.log('setCalendarEvents.data', payload.data)
            const calendarEvents = cleanDuplicates([
                ...state.calendarEvents, 
                ...payload.data
            ],
                ["Id", "customId", "customDate"],
            );
            console.log('setCalendarEvents.calendarEvents', calendarEvents)
            state.calendarEvents = calendarEvents
        },
        
    }
})


export const { 
    setStaffPositionsData,
    setCouponsResponsiblesData,
    setCouponsTypesLoading,
    setCouponsTypesError,
    setFlowId,
    setCouponsTypes,
    setCouponsTypesRangeSelectedIsValid,
    setEmployeeCouponIdRequested,
    setCouponsTypesRequestLoading,
    setCouponsTypesRequestResult,
    setCouponsTypesSuccess,
    setCouponUpdatedData,
    setContacts,
    setLoadingContacts,
    resetContactsData,
    setApprovalGroupsCompaniesLoading,
    setApprovalGroupsCompanies,
    setAssignedCompanies,
    setApprovalResponsablesLoading,
    setApprovalResponsables,
    setApprovalResponsablesReset,
    setApprovalResponsablesPartial,
    setCompanyEmployeesLoading,
    setCompanyEmployees,

    setEmployeesVacationsResumeLoading,
    setEmployeesVacationsResume,
    
    setApprovalEmployeesReset,
    setApprovalEmployeesLoading,
    setApprovalEmployeesPartial,
    setApprovalEmployees,

    setLoanUpdateStatusResult,
    setLoansToMyChargeEmployeesReset,
    setLoansToMyChargeEmployeesLoading,
    setLoansToMyChargeEmployees,
    
    setEmployeePaymentSlipsSchemeTypes,
    setCouponsToMyChargeEmployeesReset,
    setCouponsToMyChargeEmployeesLoading,
    setCouponsToMyChargeEmployeesPartial,
    setCouponsToMyChargeEmployees,
    setCouponsToMyChargeEmployeesHistoryPartial,
    setCouponsToMyChargeEmployeesHistory,
    setCouponsToApprove,
    setCouponsToApproveERPReponse,
    setDeleteCouponRejected,

    setInMyChargeEmployeeContractsReset,
    setInMyChargeEmployeeContractsLoading,
    setInMyChargeEmployeesContracts,

    setInMyChargeEmployeePaymentSlipsReset,
    setInMyChargeEmployeePaymentSlipsLoading,
    setInMyChargeEmployeesPaymentSlips,

    setInMyChargeEmployeeDocumentsReset,
    setInMyChargeDocumentsLoading,
    setInMyChargeDocuments,
    setCalendarEvents,
} = userRequestsSlice.actions
